import htmlString from './receipt-html.html?raw';

type ReceiptData = {
  providerName: string;
  providerCompanyName: string;

  dateTime: string;
  accountLast4: string;
  cardholderName: string;
  patientId: string;
  promoCode: string;
  promoDescription: string;
  promoTitle: string;
  amount: string;
  idType: string;
  expirationDate: string;
  idState: string;
};

function escapeHTML(str: string) {
  const p = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  };
  return str.replace(/[&<>"']/g, (s) => p[s as keyof typeof p]);
}
export const getReceiptHtml = (data: ReceiptData) => {
  const stringFromHtml = htmlString
    .replace(/\[providerName\]/g, escapeHTML(data.providerName))
    .replace(/\[providerCompanyName\]/g, escapeHTML(data.providerCompanyName))

    .replace(/\[dateTime\]/g, escapeHTML(data.dateTime))
    .replace(/\[accountLast4\]/g, escapeHTML(data.accountLast4))
    .replace(/\[cardholderName\]/g, escapeHTML(data.cardholderName))
    .replace(/\[patientId\]/g, escapeHTML(data.patientId))
    .replace(/\[promoCode\]/g, escapeHTML(data.promoCode))
    .replace(/\[promoDescription\]/g, escapeHTML(data.promoDescription))
    .replace(/\[promoTitle\]/g, escapeHTML(data.promoTitle))
    .replace(/\[amount\]/g, escapeHTML(data.amount))
    .replace(/\[idType\]/g, escapeHTML(data.idType))
    .replace(/\[expirationDate\]/g, escapeHTML(data.expirationDate))
    .replace(/\[idState\]/g, escapeHTML(data.idState));

  return stringFromHtml;
};
